// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pqRA","colMin":"styles_colMin__3OTRB"};